const WISHLIST_STORAGE_KEY = 'culture-house:wishlist:v1';

class CultureHouseWishlist extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.label = this.querySelector('[data-wishlist-label]');
    this.status = this.querySelector('[data-wishlist-status]');
    this.productId = this.dataset.productId;

    if (!this.button || !this.productId) return;

    this.update();
    this.button.addEventListener('click', () => this.toggle());
  }

  read() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_STORAGE_KEY) || '[]');
    } catch {
      return [];
    }
  }

  update(items = this.read()) {
    const isSaved = items.some((item) => item.id === this.productId);
    this.button.setAttribute('aria-pressed', String(isSaved));
    this.label.textContent = isSaved ? 'Saved to wishlist' : 'Add to wishlist';
  }

  toggle() {
    const items = this.read();
    const savedIndex = items.findIndex((item) => item.id === this.productId);
    let message;

    if (savedIndex >= 0) {
      items.splice(savedIndex, 1);
      message = `${this.dataset.productTitle} removed from your wishlist.`;
    } else {
      items.push({
        id: this.productId,
        title: this.dataset.productTitle,
        url: this.dataset.productUrl,
      });
      message = `${this.dataset.productTitle} saved to your wishlist on this device.`;
    }

    try {
      localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(items));
      this.update(items);
      if (this.status) this.status.textContent = message;
    } catch {
      if (this.status) this.status.textContent = 'Your wishlist could not be updated in this browser.';
    }
  }
}

class CultureHouseProductFacts extends HTMLElement {
  connectedCallback() {
    this.rows = [...this.querySelectorAll(':scope > details')];

    this.rows.forEach((row, index) => {
      const dialog = row.querySelector('dialog');
      const summary = row.querySelector('summary');
      if (!dialog || !summary) return;

      row.addEventListener('toggle', () => {
        if (!row.open) return;
        this.open(index);
      });

      dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        dialog.close();
      });

      dialog.addEventListener('close', () => {
        row.open = false;
        summary.focus();
      });

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog || event.target.closest('[data-facts-close]')) {
          dialog.close();
          return;
        }

        const switchButton = event.target.closest('[data-facts-switch]');
        if (switchButton) this.open(Number(switchButton.dataset.factsSwitch));
      });
    });
  }

  open(index) {
    const activeRow = this.rows[index];
    const activeDialog = activeRow?.querySelector('dialog');
    if (!activeRow || !activeDialog) return;

    this.rows.forEach((row) => {
      const dialog = row.querySelector('dialog');
      if (dialog?.open && dialog !== activeDialog) dialog.close();
      row.open = row === activeRow;
    });

    if (!activeDialog.open) activeDialog.showModal();
    activeDialog.querySelector('[data-facts-close]')?.focus();
  }
}

if (!customElements.get('culture-house-wishlist')) {
  customElements.define('culture-house-wishlist', CultureHouseWishlist);
}

if (!customElements.get('culture-house-product-facts')) {
  customElements.define('culture-house-product-facts', CultureHouseProductFacts);
}
